<template>
    <v-card class="mt-6">
        <v-card-title>Personal Bests</v-card-title>

        <v-tabs v-if="hasScores" v-model="stats" centered show-arrows>
            <v-tab v-if="trampolineScores.length" href="#tab-tra">TRA</v-tab>
            <v-tab v-if="doubleMiniScores.length" href="#tab-dmt">DMT</v-tab>
            <v-tab v-if="tumblingScores.length" href="#tab-tum">TUM</v-tab>
        </v-tabs>

        <v-tabs-items v-if="hasScores" v-model="stats">
            <v-tab-item v-if="trampolineScores.length" value="tab-tra">
                <v-card-text>
                    <v-list-item two-line>
                        <v-list-item-content>
                            <v-list-item-title>
                                {{ highestTrampolineScore }}
                            </v-list-item-title>
                            <v-list-item-subtitle>Total score</v-list-item-subtitle>
                        </v-list-item-content>
                    </v-list-item>

                    <v-list-item two-line>
                        <v-list-item-content>
                            <v-list-item-title>
                                {{ highestTrampolinePrelimsScore }}
                            </v-list-item-title>
                            <v-list-item-subtitle>Prelims score</v-list-item-subtitle>
                        </v-list-item-content>
                    </v-list-item>

                    <v-list-item v-if="highestTrampolineFinalsScore" two-line>
                        <v-list-item-content>
                            <v-list-item-title>
                                {{ highestTrampolineFinalsScore }}
                            </v-list-item-title>
                            <v-list-item-subtitle>Finals score</v-list-item-subtitle>
                        </v-list-item-content>
                    </v-list-item>

                    <v-list-item two-line>
                        <v-list-item-content>
                            <v-list-item-title>
                                {{ highestTrampolineDifficulty }}
                            </v-list-item-title>
                            <v-list-item-subtitle>DD</v-list-item-subtitle>
                        </v-list-item-content>
                    </v-list-item>

                    <v-list-item v-if="highestTrampolineCompulsoryTimeOfFlight !== '0.000'" two-line>
                        <v-list-item-content>
                            <v-list-item-title>
                                {{ highestTrampolineCompulsoryTimeOfFlight }}
                            </v-list-item-title>
                            <v-list-item-subtitle>CR ToF</v-list-item-subtitle>
                        </v-list-item-content>
                    </v-list-item>

                    <v-list-item v-if="highestTrampolineOptionalTimeOfFlight !== '0.000'" two-line>
                        <v-list-item-content>
                            <v-list-item-title>
                                {{ highestTrampolineOptionalTimeOfFlight }}
                            </v-list-item-title>
                            <v-list-item-subtitle>OR ToF</v-list-item-subtitle>
                        </v-list-item-content>
                    </v-list-item>
                </v-card-text>
            </v-tab-item>

            <v-tab-item v-if="doubleMiniScores.length" value="tab-dmt">
                <v-card-text>
                    <v-list-item two-line>
                        <v-list-item-content>
                            <v-list-item-title>
                                {{ highestDoubleMiniScore }}
                            </v-list-item-title>
                            <v-list-item-subtitle>Total score</v-list-item-subtitle>
                        </v-list-item-content>
                    </v-list-item>

                    <v-list-item two-line>
                        <v-list-item-content>
                            <v-list-item-title>
                                {{ highestDoubleMiniPrelimsScore }}
                            </v-list-item-title>
                            <v-list-item-subtitle>Prelims score</v-list-item-subtitle>
                        </v-list-item-content>
                    </v-list-item>

                    <v-list-item v-if="highestDoubleMiniFinalsScore" two-line>
                        <v-list-item-content>
                            <v-list-item-title>
                                {{ highestDoubleMiniFinalsScore }}
                            </v-list-item-title>
                            <v-list-item-subtitle>Finals score</v-list-item-subtitle>
                        </v-list-item-content>
                    </v-list-item>

                    <v-list-item two-line>
                        <v-list-item-content>
                            <v-list-item-title>
                                {{ highestDoubleMiniDifficulty }}
                            </v-list-item-title>
                            <v-list-item-subtitle>DD</v-list-item-subtitle>
                        </v-list-item-content>
                    </v-list-item>
                </v-card-text>
            </v-tab-item>

            <v-tab-item v-if="tumblingScores.length" value="tab-tum">
                <v-card-text>
                    <v-list-item two-line>
                        <v-list-item-content>
                            <v-list-item-title>
                                {{ highestTumblingScore }}
                            </v-list-item-title>
                            <v-list-item-subtitle>Total score</v-list-item-subtitle>
                        </v-list-item-content>
                    </v-list-item>

                    <v-list-item two-line>
                        <v-list-item-content>
                            <v-list-item-title>
                                {{ highestTumblingPrelimsScore }}
                            </v-list-item-title>
                            <v-list-item-subtitle>Prelims score</v-list-item-subtitle>
                        </v-list-item-content>
                    </v-list-item>

                    <v-list-item v-if="highestTumblingFinalsScore" two-line>
                        <v-list-item-content>
                            <v-list-item-title>
                                {{ highestTumblingFinalsScore }}
                            </v-list-item-title>
                            <v-list-item-subtitle>Finals score</v-list-item-subtitle>
                        </v-list-item-content>
                    </v-list-item>

                    <v-list-item two-line>
                        <v-list-item-content>
                            <v-list-item-title>
                                {{ highestTumblingDifficulty }}
                            </v-list-item-title>
                            <v-list-item-subtitle>DD</v-list-item-subtitle>
                        </v-list-item-content>
                    </v-list-item>
                </v-card-text>
            </v-tab-item>
        </v-tabs-items>

        <div v-if="!hasScores">
            <v-card-text>No scores yet.</v-card-text>
        </div>
    </v-card>
</template>

<script>
import numeral from 'numeral';
import Result from '@/Models/Result.js';
import TrampolineScore from '@/Models/TrampolineScore.js';
import DoubleMiniScore from '@/Models/DoubleMiniScore.js';
import TumblingScore from '@/Models/TumblingScore.js';
import Athlete from '@/Models/Athlete.js';

export default {
    name: 'AthleteStats',

    props: {
        athleteId: {
            type: Number,
            required: true,
        },
    },

    data: () => ({
        stats: null,
    }),

    computed: {
        athlete() {
            return Athlete.query().with(['results.meet']).find(this.athleteId);
        },

        trampolineScores() {
            return Result.query().where('athlete_id', this.athlete.id).where('event', 'TI').get();
        },

        highestTrampolineScore() {
            return numeral(_.first(_.orderBy(this.trampolineScores, 'total_score', 'desc')).total_score).format(
                '0.000',
            );
        },

        highestTrampolinePrelimsScore() {
            return numeral(_.first(_.orderBy(this.trampolineScores, 'prelims_score', 'desc')).prelims_score).format(
                '0.000',
            );
        },

        highestTrampolineFinalsScore() {
            if (this.trampolineScores.length === 0) {
                return null;
            }

            const highestFinalsScores = _.orderBy(
                this.trampolineScores.filter(score => !!score.finals_score),
                'finals_score',
                'desc',
            );

            const score = _.get(_.first(highestFinalsScores), 'finals_score');

            return score ? numeral(score).format('0.000') : null;
        },

        highestTrampolineDifficulty() {
            return numeral(this.routineComponent(TrampolineScore, 'dd')).format('0.0');
        },

        highestTrampolineCompulsoryTimeOfFlight() {
            return this.routineComponent(TrampolineScore, 'tof', query => query.where('num', 1));
        },

        highestTrampolineOptionalTimeOfFlight() {
            return this.routineComponent(TrampolineScore, 'tof', query => query.where('num', 2));
        },

        doubleMiniScores() {
            return Result.query().where('athlete_id', this.athlete.id).where('event', 'DM').get();
        },

        highestDoubleMiniScore() {
            return numeral(_.first(_.orderBy(this.doubleMiniScores, 'total_score', 'desc')).total_score).format('0.0');
        },

        highestDoubleMiniPrelimsScore() {
            return numeral(_.first(_.orderBy(this.doubleMiniScores, 'prelims_score', 'desc')).prelims_score).format(
                '0.0',
            );
        },

        highestDoubleMiniFinalsScore() {
            if (this.doubleMiniScores.length === 0) {
                return null;
            }

            const highestFinalsScores = _.orderBy(
                this.doubleMiniScores.filter(score => !!score.finals_score),
                'finals_score',
                'desc',
            );

            const score = _.get(_.first(highestFinalsScores), 'finals_score');

            return score ? numeral(score).format('0.0') : null;
        },

        highestDoubleMiniDifficulty() {
            return numeral(this.routineComponent(DoubleMiniScore, 'dd')).format('0.0');
        },

        tumblingScores() {
            return Result.query().where('athlete_id', this.athlete.id).where('event', 'TU').get();
        },

        highestTumblingScore() {
            return numeral(_.first(_.orderBy(this.tumblingScores, 'total_score', 'desc')).total_score).format('0.0');
        },

        highestTumblingPrelimsScore() {
            return numeral(_.first(_.orderBy(this.tumblingScores, 'prelims_score', 'desc')).prelims_score).format(
                '0.0',
            );
        },

        highestTumblingFinalsScore() {
            if (this.tumblingScores.length === 0) {
                return null;
            }

            const highestFinalsScores = _.orderBy(
                this.tumblingScores.filter(score => !!score.finals_score),
                'finals_score',
                'desc',
            );

            const score = _.get(_.first(highestFinalsScores), 'finals_score');

            return score ? numeral(score).format('0.0') : null;
        },

        highestTumblingDifficulty() {
            return this.routineComponent(TumblingScore, 'dd');
        },

        hasScores() {
            return this.trampolineScores.length || this.doubleMiniScores.length || this.tumblingScores.length;
        },
    },

    methods: {
        routineComponent(model, field, constraint) {
            let scores;

            if (model === TrampolineScore) {
                scores = this.trampolineScores;
            } else if (model === DoubleMiniScore) {
                scores = this.doubleMiniScores;
            } else if (model === TumblingScore) {
                scores = this.tumblingScores;
            }

            const query = model.query().where(score => _.map(scores, 'id').includes(score.result_id));

            if (constraint) {
                constraint(query);
            }

            const decimals = field === 'tof' ? '0.000' : '0.0';

            return numeral(_.get(query.orderBy(field, 'desc').first(), field)).format(decimals);
        },
    },
};
</script>
